// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Moment from 'moment-timezone'
import VeeValidate from 'vee-validate'
import App from './App'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import VuesticPlugin from 'vuestic-theme/vuestic-plugin'
import BootstrapVue from 'bootstrap-vue'
import FractelDashboardPlugin from 'fractel/fractel-dashboard-plugin'
import './i18n'
import Policy from './policy'
import YmapPlugin from 'vue-yandex-maps'
import ToggleButton from 'vue-js-toggle-button'
import VueMq from 'vue-mq'
import VS2 from 'vue-script2'
import VueTooltip from 'v-tooltip'
import VueFormGenerator from 'vue-form-generator/src'
import ThemeService from './services/ThemeService'

Vue.use(VuesticPlugin)
Vue.use(BootstrapVue)
Vue.use(FractelDashboardPlugin)
Vue.use(YmapPlugin)
Vue.use(ToggleButton)
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity,
  }
})
Vue.use(VS2)
Vue.use(VueFormGenerator)
Vue.use(VueTooltip)

Vue.filter('formatDate', function (value) {
  const tz = Moment.tz.guess()
  if (value) {
    return Moment(String(value)).tz(tz).format('MM/DD/YY HH:mm:ss')
  }
})
Vue.filter('formatFloat', function (value, decimal = 2) {
  if (value || value === 0) {
    const floatValue = parseFloat(value)
    return floatValue.toFixed(decimal)
  }
})
Vue.filter('formatTableRowString', function (value) {
  if (value) {
    if (value.length > 15) {
      return value.substring(0, 15) + '..'
    } else {
      return value
    }
  } else {
    return value
  }
})
Vue.filter('capitalizeFirstCharacter', function (value) {
  if (value) {
    return value.charAt(0).toUpperCase() + value.slice(1)
  } else {
    return value
  }
})

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})

sync(store, router)

let mediaHandler = () => {
  if (window.matchMedia(store.getters.config.windowMatchSizeLg).matches) {
    // store.dispatch('toggleSidebar', true)
  } else {
    store.dispatch('toggleSidebar', false)
  }
}

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  if (to.meta.requiresAuth) {
    if (localStorage.getItem('fonestorm-token')) {
      if (!to.meta.policy || Policy[to.meta.policy].can(to.meta.access)) {
        next()
      } else {
        router.push({name: 'AccessDenied'})
      }
    } else {
      router.push({name: 'Login', query: { redirect: to.path }})
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  mediaHandler()
  store.commit('setLoading', false)
})

// Initialize theme before Vue app
ThemeService.initializeTheme()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js